import { useState } from "react";

// react-router-dom components
import { Link, useNavigate, useParams } from "react-router-dom";

// @mui material components
import Grid from "@mui/material/Grid";

// @mui icons

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CommonLayout from "components/CommonLayout";

// Images
import bgImage from "assets/images/background.png";
import { Card } from "@mui/material";

const VendorSettings = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  console.log(id);


  return (
    <Card sx={{ padding: 5, marginTop: 5 }}>
      <MDBox p={1}>
        <MDBox component="form" role="form">
          <Grid container spacing={2}>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <MDTypography variant="subtitle2" className="custom_label">
                Response Time( Minutes )
              </MDTypography>
              <MDBox>
                <MDInput
                  type="text"
                  placeholder="Response Time"
                  variant="outlined"
                  fullWidth
                />
              </MDBox>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <MDTypography variant="subtitle2" className="custom_label">
                Average Delivery Time( Minutes )
              </MDTypography>
              <MDBox>
                <MDInput
                  type="text"
                  placeholder="Average Delivery Time"
                  variant="outlined"
                  fullWidth
                />
              </MDBox>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={12}>
              <MDTypography variant="subtitle2" className="custom_label">
                Delivery Fees
              </MDTypography>
              <MDBox>
                <MDInput
                  type="text"
                  placeholder="Delivery Fees"
                  variant="outlined"
                  fullWidth
                />
              </MDBox>
            </Grid>
          </Grid>

          <MDButton
            onClick={() => navigate("/manage-discount")}
            variant="gradient"
            color="success"
            sx={{ marginTop: 4 }}
          >
            Save
          </MDButton>
        </MDBox>
      </MDBox>
      </Card>

  );
};

export default VendorSettings;
